<template>
  <v-card class="radius shadow pa-5">
    <span class="title font-weight-semibold">
      <slot name="title"> Pronunciation Prompt </slot>
    </span>
    <app-editor :value="JSON.parse(content)" :editable="false" class="mr-10"></app-editor>
    <app-button-player v-if="src" :src="src" :player="false" class="absolute to-the-top" />
    <v-card-actions v-if="!disableAnswer">
      <app-microphone
        class="d-flex mx-auto"
        size="75"
        :recording="recording"
        :disabled="disabled"
        @click="triggerRecord"
      />
      <app-button-player
        v-if="computedValue"
        :src="computedValue"
        :player="false"
        playIcon="mdi-play"
        class="absolute to-the-bottom"
      />
      <v-btn
        v-if="value"
        absolute
        bottom
        left
        icon
        :loading="downloading"
        class="text-capitalize body-2 custom-text"
        @click="downloadAudio"
      >
        <v-icon>$vuetify.icons.appDownload</v-icon>
      </v-btn>
    </v-card-actions>
    <p class="text-center" v-if="!disableAnswer">
      {{ recording ? "Click to stop" : "Click to record" }}
    </p>
    <app-confirm-dialog v-model="confirmDialogModel" @yes="onYes">
      Are you sure you want to delete this voice file and record your speech again?
      <template #acceptText>Record again</template>
      <template #cancelText>Keep the file</template>
    </app-confirm-dialog>
  </v-card>
</template>
<script>
import audioMixin from "@/mixins/audioMixin";
import ConfirmDialog from "../../../../ConfirmDialog.vue";
import { getAudio } from "@/api/api";
import Microphone from "../Microphone.vue";
import Editor from "../../../../Utils/Editor.vue";
import ButtonPlayer from "../ButtonPlayer.vue";

export default {
  components: {
    appConfirmDialog: ConfirmDialog,
    appMicrophone: Microphone,
    appEditor: Editor,
    appButtonPlayer: ButtonPlayer,
  },
  props: {
    content: [String],
    src: String,
    value: [Blob, String],
    disabled: Boolean,
    disableAnswer: Boolean,
  },
  mixins: [audioMixin],
  data() {
    return {
      confirmDialogModel: false,
      downloading: false,
    };
  },
  computed: {
    computedValue() {
      if (typeof this.value === "string") {
        return this.value;
      } else if (typeof this.value === "object") {
        try {
          return URL.createObjectURL(this.value);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
          return "";
        }
      }
      return "";
    },
  },
  methods: {
    onYes() {
      this.onRecord();
      this.confirmDialogModel = false;
    },
    triggerRecord() {
      if (!this.recording && this.value) {
        this.confirmDialogModel = true;
      } else {
        this.onRecord();
      }
    },
    async downloadAudio() {
      try {
        this.downloading = true;
        let anchor = document.createElement("a");
        anchor.href = this.computedValue;
        const item = await getAudio(anchor.href);
        anchor.href = URL.createObjectURL(new Blob([item.data]));
        anchor.target = "_blank";
        anchor.download = new Date().toISOString() + ".webm";
        anchor.click();
      } finally {
        this.downloading = false;
      }
    },
  },
  created() {
    this.$on("stop-recording", () => {
      this.$emit("input", this.audioBlob);
    });
  },
};
</script>
<style scoped>
.to-the-top {
  right: 16px;
  top: 16px;
}
.to-the-bottom {
  right: 16px;
  bottom: 16px;
}
</style>
